<template>
  <div class="box-column">
    <div class="column-title">
      {{ props.title }}
      <p @click="lookMore">
        查看更多
        <el-icon><ArrowRight /></el-icon>
      </p>
    </div>
    <div
      class="column-content"
      :class="{ 'ele-have-scrollbar': props.ele_have_scrollbar }"
    >
      <slot name="abc"></slot>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { ArrowRight } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";

const router = useRouter();

// const mydata = reactive({
//     title:""
// })
const props = defineProps({
  title: {
    type: String,
    default: "标题",
  },
  path: {
    type: String,
    default: "",
  },
  routeQuery: {
    type: Object,
    default: () => {
      return {};
    },
  },
  ele_have_scrollbar: {
    type: Boolean,
    default: false,
  },
});

function lookMore() {
  // console.log(props.path);

  router.push({ path: props.path, query: props.routeQuery });
}
</script>

<style scoped lang="scss">
.box-column {
   width: 375px;
  // height:232px;
  // border:1px solid red;
  padding: 16px;
  background-color: #ffffff;
  overflow: hidden;
  // border-radius: 8px;

  > .column-title {
    // width:calc(320px - 36px);
    // height:50px;
    border-bottom: 1px dashed #cccccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    font-size: 16px;
    font-weight: 700;
    padding-bottom: 11px;
    > p {
      color: #999999;
      font-size: 14px;
      font-weight: 400;
      display: flex;
      align-items: center;

      cursor: pointer;
    }
    > p:hover{
      color:#009DE0;
    }
  }

  > .column-content {
    margin-top: 17px;
     overflow: auto;
    // height: 500px;
    // overflow: auto;
    // overflow-x: hidden;
    // overflow-y: auto;
    // margin-bottom:23px;
    // min-height:232px;
    // height:100%;
    // border:1px solid blue;
  }
}
</style>
